import { Expense, FinancePayroll, FinanceRoyalty } from "./types";

type ExpenseTemplate = { key: string; name: string; type: Expense["type"]; aliases?: string[] };
export type FinanceExpenseArticle = {
    key: string; name: string; type: Expense["type"];
    value: number | null; actual: number | null; expense: Expense | null;
    royalty?: FinanceRoyalty;
    payroll?: FinancePayroll;
};

const templates: ExpenseTemplate[] = [
    { key: "payroll", name: "ФОТ", type: "percent", aliases: ["Фонд оплаты труда"] },
    { key: "rent", name: "Аренда", type: "fixed" },
    { key: "materials", name: "Материалы", type: "percent" },
    { key: "royalty", name: "Роялти", type: "percent" },
    { key: "utilities", name: "Коммунальные услуги", type: "fixed", aliases: ["Коммуналка"] },
    { key: "communications", name: "Интернет и связь", type: "fixed" },
    { key: "marketing", name: "Маркетинг", type: "fixed" },
    { key: "other", name: "Прочие расходы", type: "fixed", aliases: ["Прочее"] },
];
const normalized = (name: string) => name.trim().replace(/\s+/g, " ").toLocaleLowerCase("ru-RU").replace(/ё/g, "е");
export const isRoyaltyExpense = (name: string) => normalized(name) === "роялти";
export const isPayrollExpense = (name: string) => ["фот", "фонд оплаты труда"].includes(normalized(name));
const savedArticle = (expense: Expense): FinanceExpenseArticle => ({ ...expense, key: "expense:" + expense.id, expense });

/** Missing standard articles are empty forms, not recorded costs or assumed amounts. */
export function financeExpenseArticles(expenses: Expense[], includeDefaults = true, royalty?: FinanceRoyalty, payroll?: FinancePayroll): FinanceExpenseArticle[] {
    if (!includeDefaults) return expenses.map(savedArticle);
    const remaining = [...expenses];
    const articles = templates.map(template => {
        const names = [template.name, ...(template.aliases || [])].map(normalized);
        const index = remaining.findIndex(expense => names.includes(normalized(expense.name)));
        if (index >= 0) {
            const [expense] = remaining.splice(index, 1);
            return { ...savedArticle(expense), name: template.name };
        }
        return { key: "template:" + template.key, name: template.name, type: template.type, value: null, actual: null, expense: null };
    });
    return [...articles, ...remaining.map(savedArticle)].map(article => payroll && isPayrollExpense(article.name)
        ? { ...article, actual: payroll.actual, payroll }
        : isRoyaltyExpense(article.name)
        ? { ...article, type: "percent", value: royalty?.ratePercent ?? null, actual: article.expense ? article.actual : royalty?.calculatedAmount ?? null, royalty: royalty || { source: "unavailable", ratePercent: null } }
        : article);
}
